<template>
  <div class="organization">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">组织机构</span>
        <div class="head-text">
          <el-button type="primary" @click="addtable(1)">新增主类</el-button>
        </div>
      </div>
      <div class="rygl-table">
        <el-table
          :data="inform"
          class="w100-mar-bot20"
          row-key="ID"
          height="72vh"
          v-loading="loading"
          default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            align="center"
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            align="center"
            type="index"
            label="序号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="label"
            label="名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Content"
            label="备注"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Count"
            label="人员数量"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="user"
            label="维护人员"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="DateTime"
            label="更新时间"
          ></el-table-column>
          <el-table-column align="center" label="操作" width="400">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                plain
                @click="addtable(2, scope.row)"
                >查看</el-button
              >
              <el-button
                size="small"
                type="primary"
                plain
                @click="UpdateName(scope.row)"
                >重命名</el-button
              >
              <el-button
                size="small"
                type="primary"
                plain
                @click="addtable(4, scope.row)"
                >新增子级</el-button
              >
              <el-button
                size="small"
                type="danger"
                plain
                @click="deleteinfo(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 新增 -->
      <el-dialog :close-on-click-modal = "false" :title="titles" :visible.sync="addDialogFormVisible">
        <el-form :model="addinform" label-width="80px" ref="addForm1">
          <el-form-item label="名称" prop="prde03">
            <el-input
              type="text"
              :disabled="disabled"
              v-model="addinform.prde03"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="prde04">
            <el-input
              type="text"
              :disabled="disabled"
              v-model="addinform.prde04"
            ></el-input>
          </el-form-item>
        </el-form>
        <div align="center">
          <el-button type="primary" class="mar-bot20" @click="addUserSubmit()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 重命名 -->
      <el-dialog :close-on-click-modal = "false" title="重命名" :visible.sync="addDialogFormVisibleName">
        <el-input type="text" v-model="names" auto-complete="off"></el-input>

        <div align="center" class="padding20">
          <el-button
            class="margin-top20"
            type="primary"
            @click="UpdateNameBtn()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- <el-pagination
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagenum"
        :page-sizes="[100,50,10]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>-->
    </el-card>
  </div>
</template>

<script>
import {
  GetteamOrganization,
  Addteam,
  EditProdept,
  GetteamMember,
  DelProdept,
  GetteamMemberUser
} from "@/setAxios.js";
export default {
  name: "ProjectInformation",
  data() {
    return {
      loading: false,
      total: 0,
      pagesize: 10,
      pagenum: 1,
      addDialogFormVisible: false,
      addDialogFormVisibleName: false,
      editorDialogFormVisible1: false,
      inform: [],
      names: null,
      UpdateNameData: {},
      addinform: {
        prde06: new Date(),
        prde07: 0,
        prde05: localStorage.getItem("id"),
        prde02: localStorage.getItem("xid")
      },
      tableData1: [],
      froms: [],
      addForm: {
        noti02: "",
        noti03: "",
        noti04: "",
        noti05: ""
      },
      addForm1: {
        noti02: "",
        noti03: "",
        noti04: "",
        noti05: ""
      },
      arrs: null,
      titles: "表单",
      disabled: false
    };
  },
  methods: {
    //   重命名
    UpdateName(row) {
      //(row, "name");
      this.addDialogFormVisibleName = true;
      let params = { bid: row.ID };
      GetteamMemberUser({ params }).then(res => {
        //(res, "bidlist");
        this.UpdateNameData = res.Data;
        this.names = res.Data.prde03;
      });
    },
    //  重命名确定按钮
    UpdateNameBtn() {
      //(this.UpdateNameData, "fff");

      let name = this.names;
      let id = this.UpdateNameData.prde01;
      EditProdept({ name, id }).then(res => {
        //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "重命名成功"
          });
          this.getData();
          this.addDialogFormVisibleName = false;
        } else {
          this.$message.error("重命名失败");
        }
      });
    },
    //   打开列表
    addtable(arr, row) {
      //(arr, row);
      this.addinform = this.$options.data().addinform;
      this.addDialogFormVisible = true;
      this.arrs = arr;
      if (arr === 1) {
        this.disabled = false;
        this.titles = "新增";
      } else if (arr === 2) {
        this.titles = "查看";
        this.disabled = true;
        this.addinform.prde03 = row.label;
        this.addinform.prde04 = row.Content;
      } else if (arr === 3) {
        this.disabled = false;
        this.titles = "编辑";
      } else {
        this.disabled = false;
        this.titles = "新增子集";
        this.addinform.prde07 = row.ID;
      }
    },
    //   新增确定键
    addUserSubmit() {
      if (this.arrs === 1) {
        let params = JSON.stringify(this.addinform);
        Addteam({ prodept: params }).then(res => {
          //(res);
          if (res.Code === 1) {
            this.$message({
              type: "success",
              message: "新增成功"
            });
            this.getData();
            this.addDialogFormVisible = false;
          } else {
            this.$message.error("新增失败");
          }
        });
      } else if (this.arrs === 2) {
        this.addDialogFormVisible = false;
      } else if (this.arrs === 3) {
      } else if (this.arrs === 4) {
        let params = JSON.stringify(this.addinform);
        Addteam({ prodept: params }).then(res => {
          //(res);
          if (res.Code === 1) {
            this.$message({
              type: "success",
              message: "添加子集成功"
            });
            this.getData();
            this.addDialogFormVisible = false;
          } else {
            this.$message.error("添加子集失败");
          }
        });
      }
    },
    //   删除
    deleteinfo(row) {
      //(row);
      this.loading = true;
      let bid = JSON.stringify(row.ID);
      let xid = localStorage.getItem("xid");
      this.$confirm("是否删除该组织机构?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          DelProdept({ xid, bid }).then(res => {
            //(res);
            if (res.Code === 1) {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.loading = false;
            }
            this.getData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   编辑通知公告
    editor() {
      this.editorDialogFormVisible1 = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getData();
    },
    // 获取所有数据
    getData() {
      this.loading = true;
      let params = {
        id: localStorage.getItem("xid")
      };
      GetteamOrganization({ params }).then(res => {
        //(res, "1");
        this.inform = res.Data;
        // this.total = res.Data.total;
        this.loading = false;
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.w100-mar-bot20 {
  width: 100%;
  margin-bottom: 20px;
}
.mar-bot20 {
  margin-bottom: 20px;
}
.padding20 {
  padding: 20px;
}
.margin-top20 {
  margin-top: 20px;
}
</style>
